export default "__VITE_ASSET__DwdgJUlo__"